import { render, staticRenderFns } from "./TierManager.vue?vue&type=template&id=32ee8800&scoped=true"
import script from "./TierManager.vue?vue&type=script&lang=js"
export * from "./TierManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ee8800",
  null
  
)

export default component.exports